import React, { ReactElement } from 'react';
import { Tabs, Card, Input } from 'antd';

const { TextArea } = Input;

interface PageProps {
  value?: any
  onChange?: (value?: any) => void;
  disabled?: boolean
}

interface PageState {

}

interface Page {

}

export default class JJ_FromI18nTextAreaByDefault extends React.Component<PageProps, PageState> implements Page {

  componentDidMount() {


  }


  constructor (props: any) {
    super(props);
    this.state = {}
  }

  render() {
    const tabDatas = [
      { title: 'English', value: 'en' },
      { title: '繁體中文', value: 'zh-tw' },
    ]
    return (
      <Card>
        <Tabs
          defaultActiveKey="1"
          type='card'
        >
          {tabDatas.map(item => {
            const value: any = this.props.value || {}

            return (
              <Tabs.TabPane
                tab={item.title}
                key={item.value}
              >
                <TextArea
                  disabled={this.props.disabled}
                  rows={4}
                  defaultValue={value[item.value]}
                  // value={value[item.value]}
                  onChange={v => {
                    const newValue: any = this.props.value || {}
                    newValue[item.value] = v.target.value
                    this.props.onChange && this.props.onChange({
                      'zh-tw': '',
                      'en': '',
                      ...(newValue || {}),
                    })

                  }}
                />
              </Tabs.TabPane>
            )
          })}
        </Tabs>
      </Card>
    )
  }

}


